module.exports = __webpack_public_path__ + "static/media/hamburger-menu.dc243461.svg";